import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight, Tv } from "lucide-react";
import { useTranslate } from "../context/TranslateContext";
import { LANDMARK_SERIALS } from "../mock/articles";

// Horizontal strip of iconic Indian serials, embedded inside the Serials article.
export const LandmarkSerials = () => {
  const { t } = useTranslate();
  return (
    <div className="!mt-10 rounded-3xl border border-edge bg-surface/40 p-6 md:p-8" data-testid="landmark-serials">
      <div className="mb-6 flex items-center gap-3">
        <Tv className="h-5 w-5 text-gold" />
        <h3 className="font-display text-2xl font-semibold text-cream md:text-3xl">{t("Landmark serials")}</h3>
        <div className="h-px flex-1 bg-edge" />
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 lg:grid lg:grid-cols-4 lg:gap-5 lg:overflow-visible">
        {LANDMARK_SERIALS.map((s, i) => (
          <motion.div key={s.slug} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.04 }}>
            <Link to={`/landmark/${s.slug}`} data-testid={`landmark-card-${s.slug}`}
              className="group flex h-full w-64 shrink-0 flex-col justify-between overflow-hidden rounded-2xl border border-edge bg-paper transition-colors duration-300 hover:border-gold/60 lg:w-auto">
              <div className="relative h-24 overflow-hidden" style={{ background: `linear-gradient(135deg, ${s.accent}, ${s.accent}22)` }}>
                <span className="absolute right-3 top-3 rounded-full bg-paper/85 px-2.5 py-1 font-display text-sm font-semibold text-cream backdrop-blur">{s.year}</span>
                <span className="absolute bottom-3 left-4 font-body text-xs uppercase tracking-widest text-paper/90">{t(s.genre)}</span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="font-display text-lg font-semibold leading-tight text-cream">{s.title}</div>
                <div className="mt-1 font-body text-xs text-gold">{s.channel} · {t(s.language)}</div>
                <p className="mt-2 flex-1 font-body text-sm leading-relaxed text-ash">{t(s.tagline)}</p>
                <span className="mt-3 inline-flex items-center gap-1 font-body text-sm text-gold">
                  {t("Read more")} <ChevronRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
